export default "assets/images/icons/white-circle-6678b781.svg";